import { ANALYTICS_COOKIE_NAME } from "@monorepo/constants";

export const getIsAnalyticsCookieAccepted = () => getCookieValue(ANALYTICS_COOKIE_NAME) === "true";

export const getCookieValue = (cookieName: string) =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${cookieName}=`))
    ?.split("=")[1];
